import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Fab } from '@material-ui/core';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import { useHistory } from 'react-router-dom';

const ChatBar = props => {
  const classes = useStyles();
  const history = useHistory();

  const handleImportFile = () => {
    history.push('/transfer/import-file');
  };

  return (
    <Fragment>
      <span className={classes.fab}>
        <Fab
          color="primary"
          onClick={handleImportFile}
        >
          <InsertDriveFileIcon />
        </Fab>
      </span>
    </Fragment>
  );
};

ChatBar.propTypes = {
  className: PropTypes.string
};

export default ChatBar;

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 280
  },
  root: {
    backgroundColor: theme.palette.white
  },
  list: {
    padding: theme.spacing(1, 3)
  },
  listItemText: {
    marginRight: theme.spacing(1)
  },
  lastActivity: {
    whiteSpace: 'nowrap'
  },
  fab: {
    position: 'fixed',
    bottom: 32,
    right: 32,
    zIndex: theme.zIndex.drawer - 100
  }
}));
